module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/fulfillment.release/~/core-js/modules/_is-object.js
// module id = ../../../../core-js/modules/_is-object.js
// module chunks = 1